<template lang="html">
  <StandardDialog @click-outside="$router.push({ name: 'ProjectOverView'})">
    <template #content v-if="!deleteView">
      <!-- Flexbox: Dialog Content -->
      <TFlex style="width:100%; flex-direction: column;" class="pa-5">
        <!-- Flexbox: Header +  Header Actions -->
        <div class="multi-project-details-dialoge-header">
          <TText
            size="20"
            font_weight="500"
            :text="getUObject({ type: 'multiprojects', id: multiproject_id}).name"
          />
          <div class="multi-project-details-dialoge-header-buttons">
            <ButtonOutlined
              icon="bin-delete"
              value="Delete"
              width="110"
              @buttonClicked="deleteView = true"
            />
            <ButtonOutlined
              icon="pencil"
              value="Edit"
              width="110"
              @buttonClicked="$router.push({name: 'MultiProjectEditDialog', params: {multiproject_id: multiproject_id}})"
            />
            <ButtonOutlined
              icon="calendar"
              value="Schedule"
              width="110"
              @buttonClicked="$router.push({name: 'MultiProjectSchedule', params: {multiproject_id: multiproject_id}})"
            />
            <ButtonOutlined
              icon="sign-close"
              value="Close"
              width="110"
              @buttonClicked="$router.push({ name: 'ProjectOverView'})"
            />
          </div>
        </div>
        <!-- Flexbox: Description + Infobox -->
        <TFlex style="width:100%">

        </TFlex>
        <!-- Flexbox: Projects -->
        <TFlex
          wrap="wrap"
          style="width:100%"
          v-if="getUObjects({ type: 'projects', ids: getUObject({ type: 'multiprojects', id: multiproject_id}).projects }).length > 0"
        >
          <ProjectCard
            v-for="project in getUObjects({ type: 'projects', ids: getUObject({ type: 'multiprojects', id: multiproject_id}).projects })"
            :key="project.id"
            :width="`calc(${1/3} * (100% - 30px))`"
            :image="project.image ? project.image : ''"
            content_height="200px"
            height="300px"
            class="ma-1"
            :header="project.name"
            :checkbox="false"
            :project_information="project.information"
            @clickAll="$router.push({
              name: 'ProjectTaktPlan',
              params: {project_id: project.id}
            })"
          >
            <template #image>
              {{project.name}}
            </template>
            <template #body>
              <div style="display: flex;" class="project-info-projectrole">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-col v-on="on" cols="2">
                      <v-row>
                        <v-icon>person</v-icon>
                        <div>{{project.prole}}</div>
                      </v-row>
                    </v-col>
                  </template>
                  <span></span>
                </v-tooltip>
                <div class="project-info-workpackages">
                  <WorkPackage
                    v-for="(work_package, index) in project.work_packages"
                    :key="index"
                    :color="`${work_package.color} ${work_package.color.includes('lighten') || work_package.color.includes('darken')? '':'lighten-1'}`"
                    :token="work_package.token"
                    :icon="work_package.icon"
                    :zoom="1"
                    >
                    <template #workpackage>
                      <StandardBadge
                        color="white"
                        :text="work_package.count"
                        content_color="black"
                      />
                    </template>
                  </WorkPackage>
                </div>
              </div>
            </template>
            <template #buttons>
                <TFlex align_items="flex-start;">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <span
                        v-bind="attrs"
                        v-on="on"
                        @click.stop="project_id_loading = project.id; $router.push({
                          name: 'ProjectWallet',
                          params: {
                            project_id: project.id,
                            takt_index: 1,
                            calculate_takt_time: true
                          }
                        });"
                      >
                        <svg-icon
                          class="mr-1 cursor-pointer"
                          name="takt_wallet"
                          :size="30"
                          ></svg-icon>
                      </span>
                    </template>
                    <span><TText value="TAKT.wallet"/></span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <span
                        v-bind="attrs"
                        v-on="on"
                        @click.stop="project_id_loading = project.id; $router.push({
                          name: 'ProjectTaktJournal',
                          params: {project_id: project.id}
                        });"
                      >
                        <svg-icon
                          class="mr-1 cursor-pointer"
                          name="takt_journal"
                          :size="30"
                        />
                      </span>
                    </template>
                    <span><TText value="TAKT.journal"/></span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <span
                        v-bind="attrs"
                        v-on="on"
                        @click.stop="project_id_loading = project.id; $router.push({
                          name: 'ProjectStructure',
                          params: {project_id: project.id}
                        });"
                      >
                        <svg-icon
                          class="mr-1 cursor-pointer"
                          name="takt_taktspace"
                          :size="30"
                        />
                      </span>
                    </template>
                    <span><TText value="PROJECT.structure"/></span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        v-bind="attrs"
                        v-on="on"
                        @click.stop="project_id_loading = project.id; $router.push({
                          name: 'ProjectSettings',
                          params: {project_id: project.id}
                        });"
                        class="mr-1 cursor-pointer"
                        style="margin-top:-2px;"
                        :size="32"
                      >
                        settings_applications
                      </v-icon>
                    </template>
                    <span><TText value="PROJECT.settings"/></span>
                  </v-tooltip>
                </TFlex>
            </template>
          </ProjectCard>
        </TFlex>
        <TFlex style="width:100%" v-else>
          No projects added... add projects:
          <v-btn @click="$router.push({
            name: 'MultiProjectEditDialog',
            params: {
              multiproject_id: multiproject_id
            }
          })"><TText value="edit"/></v-btn>
        </TFlex>
      </TFlex>
    </template>
    <template #content v-else>
      <TFlex style="width:100%;" justify_content="space-between" align_items="center">
        <TText
          size="20"
          font_weight="500"
          :text="'Delete Multiproject: ' + getUObject({ type: 'multiprojects', id: multiproject_id}).name + '?'"
        />
        <TFlex justify_content="flex-end">
          <v-btn class="mr-2" @click="deleteUObject({
              url: [
                { multiprojects: multiproject_id },
              ]
            }).then($router.push({ name: 'ProjectOverView'}))">
          <TIcon
            name="bin-delete"
            color="white"
          />
          Delete
        </v-btn>
        <v-btn class="mr-2" @click="deleteView = false">
        <TIcon
          name="sign-close"
          color="white"
        />
        Cancel
      </v-btn>
        </TFlex>
      </TFlex>
    </template>
  </StandardDialog>
</template>

<script>

import {
  mapActions,
  mapGetters
} from 'vuex';

import StandardDialog from '@/components/StandardComponents/StandardDialog.component.vue';
import ProjectCard from '@/components/ProjectOverView/ProjectCard.component.vue'
import TFlex from '@/components/Taktify/TFlex.component.vue';
import TText from '@/components/Taktify/TText.component.vue';
import TIcon from '@/components/Taktify/TIcon.component.vue';
import ButtonOutlined from '@/components/WorkPackageWIP/ButtonOutlined.component.vue';

export default {
  data: () => ({
    deleteView: false
  }),
  name: 'MultiProjectDetailsDialog',
  components: {
    ProjectCard,
    StandardDialog,
    TFlex,
    TText,
    TIcon,
    ButtonOutlined,
  },
  props: ['multiproject_id'],
  computed: {
    ...mapGetters('Ultra', [
      'getUObject',
      'getUObjects',
    ]),
    ...mapGetters('Project', [
      'getProjectOverview',
    ]),
    columns(){
      if (this.$vuetify.breakpoint.smAndDown) {
        return 1;
      } else if(this.$vuetify.breakpoint.mdOnly) {
        return 2;
      } else {
        return 3;
      }
    }
  },
  methods: {
    ...mapActions('Ultra', [
      'deleteUObject'
    ]),
  }
}
</script>

<style>
.multi-project-details-dialoge-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 8px;
}
.multi-project-details-dialoge-header-buttons {
  display: flex;
  justify-content: flex-end;
  grid-gap: 8px;
}
</style>
